import { Field, Textarea } from '../../../ui/forms';
import { ConfirmDialog } from '../../../ui/Modal';
import type { ReleaseDetail } from '../types';
import { EditCandidate } from './EditCandidate';
import type { ReleaseActions } from './useReleaseActions';
export function ReleaseDialogs({ r, actions }: { r: ReleaseDetail; actions: ReleaseActions }) {
  const { dialog, setDialog, inv, request, proceed, cancel, text, setText } = actions;
  const b = r.candidate?.binding;
  return (
    <>
      {dialog === 'edit' && <EditCandidate r={r} onClose={() => setDialog(null)} inv={inv} />}
      {dialog === 'request' && (
        <ConfirmDialog
          title={
            b?.deliveryMethod === 'external_record'
              ? `Submit existing deployment for ${r.displayId}?`
              : `Request approval for ${r.displayId}?`
          }
          confirmLabel={b?.deliveryMethod === 'external_record' ? 'Submit for review' : 'Request approval'}
          onClose={() => setDialog(null)}
          onConfirm={() => request.mutate(undefined)}
          pending={request.isPending}
          error={request.error}
        >
          <p>
            {b?.deliveryMethod === 'external_record' ? (
              'Jira validates the reported deployed revision and evidence. Admin acceptance records delivery and closes eligible completion-target tickets without deploying anything.'
            ) : (
              <>
                Jira freezes the head of {b?.deployRef ?? 'the default branch'} into the candidate, and an
                admin approves that exact revision. Any later change makes the request stale.
              </>
            )}
          </p>
          <Field label="Rationale" optional>
            {(p) => <Textarea {...p} rows={3} value={text} onChange={(e) => setText(e.target.value)} />}
          </Field>
        </ConfirmDialog>
      )}
      {dialog === 'proceed' && (
        <ConfirmDialog
          title={`Deploy ${r.displayId} to ${r.environment.name}?`}
          confirmLabel={`Start ATT-${r.attemptCount + 1}`}
          onClose={() => setDialog(null)}
          onConfirm={() => proceed.mutate(undefined)}
          pending={proceed.isPending}
          error={proceed.error}
        >
          <p>
            {r.environment.requiresApproval
              ? `This attempt uses approved revision ${b?.sourceRevision?.slice(0, 12) ?? ''} and approval ${r.viewer.approvalToUse?.displayId ?? ''}.`
              : `Jira freezes the current head of ${r.mergeGate?.defaultBranch ?? 'the default branch'}, after checking it contains every merged pull request and that its CI passed.`}{' '}
            {b?.deliveryMethod === 'manual' ? (
              'It registers a manual attempt with you as executor. Deploy the approved revision using the plan and report the actual outcome with every required check.'
            ) : (
              <>
                It then runs <span className="mono">{r.environment.deployWorkflow}</span> once, with you as
                the executor. The run reports its result to the attempt.
              </>
            )}
          </p>
        </ConfirmDialog>
      )}
      {dialog === 'cancel' && (
        <ConfirmDialog
          title={`Cancel ${r.displayId}?`}
          confirmLabel="Yes, cancel"
          variant="danger"
          onClose={() => setDialog(null)}
          onConfirm={() => cancel.mutate(undefined)}
          pending={cancel.isPending}
          error={cancel.error}
          disabled={!text.trim()}
        >
          <p>
            Reservations are released and outstanding approvals become stale. Previous attempts stay in
            history.
          </p>
          <Field label="Reason">
            {(p) => <Textarea {...p} rows={2} value={text} onChange={(e) => setText(e.target.value)} />}
          </Field>
        </ConfirmDialog>
      )}
    </>
  );
}
